import React from "react";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  background-color: #F2F3F7;
  font-family: "Open Sans", sans-serif;
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  width: 100%;
  padding: 30px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  height: 70px;
`;

const Title = styled.h1`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 20px;
  
  span:first-child {
    font-size: 15px;
    color: ${props => props.theme.lightTextColor};
  }
`;

interface DashboardProps {
  title: string;
  children?: React.ReactNode;
}

const Dashboard = ({title, children}: DashboardProps) => {
  return <Container>
    <Wrapper>
      <Header>
        <Title>
          <span>OWL Monitor for developers</span>
          <span>{title}</span>
        </Title>
      </Header>
      {children}
    </Wrapper>
  </Container>
}

export default Dashboard;